export default {
  namespaced: true,
  chat: {
    error: "No tienes un usuario para el chat",
    new_message: "Nuevo mensaje de {user}",
    new_emergency_chat: "Nuevo Chat de Emergencia",
    emergency_groups: "Chats de Emergencia",
    group_name: "Nombre de grupo",
    users: "Usuários",
    chats: "Chats",
    contacts: "Contactos",
    chats_group: "Grupo de chats",
    start_conversation: "Iniciar conversación",
    send: "Enviar",
    eliminated : "Eliminó",
    added : "Agregó",
    no_room_found_text: "No se encontró ninguna sala",
    end_chat: "Terminar",
    chat_has_ended: "El chat ha terminado.",
    finalized: "Finalizado",
    assigned: "Asignado",
    all: "Todo",
  }
}
